export const chatTranslations = {
  en: {
    title: 'Live Chat',
    chatTitle: 'Let\'s Talk Business',
    chatSubtitle: 'Connect with our AI assistant instantly and discuss your next project. We\'re here to help you turn your ideas into reality.',
    welcomeMessage: 'Hello! I\'m DESTA AI Assistant. I can help you with our services, provide quotes, and connect you with our team. How can I assist you today?',
    messagePlaceholder: 'Type your message here...',
    sendButton: 'Send',
    typing: 'AI is thinking...',
    autoResponse: 'Thank you for your message! We will contact you shortly.',
    errorResponse: 'Sorry, I\'m having trouble responding right now. Please try again later.',
    otherContacts: 'Other ways to reach us',
    backToHome: '← To home'
  },
  uk: {
    title: 'Живий чат',
    chatTitle: 'Давайте обговоримо бізнес',
    chatSubtitle: 'Зв\'яжіться з нашим AI асистентом миттєво та обговоріть ваш наступний проект. Ми тут, щоб допомогти втілити ваші ідеї в реальність.',
    welcomeMessage: 'Привіт! Я AI Асистент DESTA. Я можу допомогти вам з нашими послугами, надати кошторис та з\'єднати вас з нашою командою. Як можу вам допомогти сьогодні?',
    messagePlaceholder: 'Введіть ваше повідомлення тут...',
    sendButton: 'Надіслати',
    typing: 'AI думає...',
    autoResponse: 'Дякуємо за ваше повідомлення! Ми зв\'яжемося з вами найближчим часом.',
    errorResponse: 'Вибачте, у мене проблеми з відповіддю зараз. Будь ласка, спробуйте пізніше.',
    otherContacts: 'Інші способи зв\'язку з нами',
    backToHome: '← На головну'
  }
};